import Vue from 'vue';
import Component from 'vue-class-component';

import BbModal from 'common/components/BbModal';
import useFilters from 'composables/useFilters';

import Facet from 'components/DynamicFilters/Facet/Facet.vue';
import OptionCards from 'components/DynamicFilters/OptionCards/OptionCards.vue';
import SearchTags from 'components/DynamicFilters/SearchTags/SearchTags.vue';

import orderOptions from 'constants/orderOptions';

import filterIcon from 'assets/icons/filterIcon.svg';
import arrowIcon from 'common/icons/Chevron.svg';
import useCatalogFilters from 'composables/useCatalogFilters';

@Component({
  components: {
    SearchTags,
    BbModal,
    OptionCards,
    Facet,
  },
  props: {
    isBoxCatalog: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const filterStore = props.isBoxCatalog ? useCatalogFilters() : useFilters();
    const {
      getFacets,
      clearCurrentFilters,
      getCardSelected,
      getCurrentFilters,
      getCurrentOrder,
      getPageInfo,
      getCurrentTags,
      handleChangeFilters,
    } = filterStore;
    return {
      facetList: getFacets,
      resetFilters: clearCurrentFilters,
      cardSelected: getCardSelected,
      currentFilters: getCurrentFilters,
      currentOrder: getCurrentOrder,
      currentTags: getCurrentTags,
      pageInfo: getPageInfo,
      handleChange: handleChangeFilters,
    };
  },
})
export default class FilterMobileComponent extends Vue {
  orderOptions = orderOptions;
  icons = {
    filter: filterIcon,
    arrow: arrowIcon,
  };
  showModal = false;
  showOrdering = false;
  selectedOrder = 'relevance';
  toggleOrdering() {
    this.showOrdering = !this.showOrdering;
  }

  get _orderOptions() {
    if (!this.orderOptions) return [];

    return this.isBoxCatalog
      ? this.orderOptions.boxCatalogOptions
      : this.orderOptions.nonBoxCatalogOptions;
  }

  get currentOrderName() {
    return this._orderOptions.find(o => o.value === this.currentOrder)?.title;
  }

  get onlineReservationFacet() {
    return this.facetList.find(item => item.show_name === 'Reserva online');
  }
}
